<template>
  <p>
    El fotómetro solar (sunphotometer) sirve para realizar mediciones de la
    irradiancia solar directa y del cielo. Mediante 8 filtros estas mediciones
    se realizan centrados en las longitudes de onda de 340, 380, 440, 500, 675,
    870, 1020 y 1640 nm. Su frecuencia de medición es de cada 3 minutos. A
    partir de estas mediciones, con la aplicación de la ley de
    Lambert-Beer-Bouguer y de modelos de transferencia radiativa se obtienen un
    conjunto de propiedades físicas, ópticas y radiativas de los aerosoles
    atmosféricos. Este fotómetro es parte de la red AERONET de la NASA.
  </p>
  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/fotometro.webp"
    alt="Fotómetro solar"
  />
  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Espesor óptico de aerosol (Aerosol optical depth, AOD)</li>
    <li>Coeficiente de Ångström.</li>
    <li>Albedo de dispersión simple (Single Scattering Albedo, SSA)</li>
    <li>Distribución del tamaño de aerosol</li>
    <li>Contenido total de vapor de agua precipitable</li>
    <li>Sección eficaz de extinción por dispersión</li>
    <li>Sección eficaz de extinción por absorción</li>
  </List>
  <p>
    <b>Datos disponibles en: </b> <br />
    <a href="https://bit.ly/aeronethyo" target="_blank"
      >https://bit.ly/aeronethyo</a
    >
  </p>
  <p>
    <b>Marca y modelo: </b> <br />
    Cimel, CE318-T
  </p>
  <p>
    <b>País: </b> <br />
    Francia
  </p>
  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a href="https://www.cimel.fr/solutions/ce318-t/" target="_blank"
      >https://www.cimel.fr/solutions/ce318-t/</a
    >
  </p>
  <p>
    <b>Responsable: </b> <br />
    lsuarez@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  // Obtener el nombre de la ruta

  name: "FotometroSolar",
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
  components: { List },
};
</script>
